<!-- A component to display a medium heading -->
<template>
	<div
		v-html="richTextHtml"
		class="leading-tighter [&_i]:text-primary-700 text-secondary-900 font-serif text-5xl [&_i]:font-bold"
	></div>
</template>

<script setup lang="ts">
defineProps({
	richTextHtml: {
		type: String,
		required: true,
	},
})
</script>
